const LoadingSpinner = () => <div className="loading-spinner"></div>;

export default LoadingSpinner;